class NotificationPopup extends HTMLElement {
    constructor() {
      super();
    }
  
     
   connectedCallback() {
        this.popup = this.closest('.not-pu-section');
        this.closeBtn = this.popup.querySelector('.newsletter__close-btn');
        this.hasSubscription = Boolean(this.dataset.hasSubscription === "true");
        this.isPrivateSale = this.dataset.privateSale === "true";
        
        // Controlla se siamo nella homepage (incluse le versioni in altre lingue)
        const pathname = window.location.pathname;
        const isHomepage = pathname === '/' || 
                          pathname === '/index' || 
                          pathname === '/home' ||
                          pathname === '/en' ||
                          pathname === '/en/' ||
                          pathname === '/en/index' ||
                          pathname === '/it' ||
                          pathname === '/it/' ||
                          pathname === '/it/index' ||
                          pathname.match(/^\/[a-z]{2}(-[A-Z]{2})?\/?(index)?$/); // Matches language codes like /en, /it, /en-US, etc.
        
        // Private Sale anche agli iscritti; il popup newsletter conserva la regola originale.
        if (!isHomepage || (this.hasSubscription && !this.isPrivateSale)) return;

        this.popup.classList.remove('hidden')

        this.closeBtn.addEventListener('click', () => {
            this.popup.classList.add('hidden')
        });
        this.onEscape = (event) => {
            if (event.key === 'Escape') this.popup.classList.add('hidden');
        };
        document.addEventListener('keydown', this.onEscape);          
    }
  
    disconnectedCallback() {
        if (this.onEscape) document.removeEventListener('keydown', this.onEscape);
    }

    setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Convert days to milliseconds
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }
}

customElements.define("notification-popup", NotificationPopup);

// Funzione per copiare il codice coupon
function copyCouponCode() {
    const couponText = document.getElementById('coupon-code-text');
    const couponCode = couponText.textContent;
    
    // Usa l'API Clipboard moderna se disponibile
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(couponCode).then(() => {
            showCopySuccess();
        }).catch(err => {
            console.error('Errore nel copiare il codice:', err);
            fallbackCopyTextToClipboard(couponCode);
        });
    } else {
        // Fallback per browser più vecchi
        fallbackCopyTextToClipboard(couponCode);
    }
}

// Fallback per browser che non supportano l'API Clipboard
function fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
        const successful = document.execCommand('copy');
        if (successful) {
            showCopySuccess();
        } else {
            alert('Impossibile copiare il codice. Copia manualmente: ' + text);
        }
    } catch (err) {
        console.error('Errore nel copiare il codice:', err);
        alert('Impossibile copiare il codice. Copia manualmente: ' + text);
    }
    
    document.body.removeChild(textArea);
}

// Mostra messaggio di successo per la copia
function showCopySuccess() {
    const copyButton = document.querySelector('.coupon-code button');
    const originalText = copyButton.textContent;
    
    copyButton.textContent = 'Copiato!';
    copyButton.style.background = '#28a745';
    
    setTimeout(() => {
        copyButton.textContent = originalText;
        copyButton.style.background = '#007bff';
    }, 2000);
}
// Mostra messaggio di successo per la copia
function showCopySuccess() {
    const copyButton = document.querySelector('.coupon-code button');
    const originalText = copyButton.textContent;
    
    copyButton.textContent = 'Copiato!';
    copyButton.style.background = '#28a745';
    
    setTimeout(() => {
        copyButton.textContent = originalText;
        copyButton.style.background = '#007bff';
    }, 2000);
}


